<template>
  <div >
    <Header
        :leftArrow="true"
        :leftText="''"
        @leftClick="onClickLeft"
        @onRefreshClick="onRefresh"
        :rightIcons="true"
    >
    </Header>
    <div v-html="showText" class="showTextClass">
    </div>
    <van-button type="primary" @click="onStart" class="btn-start" :disabled="recordOn">
      スタート
    </van-button>
    <van-button type="primary" @click="onStop" class="btn-stop" :disabled="!recordOn">
      終了
    </van-button>
  </div>

</template>

<script>
import Header from "@/components/Header.vue";
import {Toast} from "vant";
import "vant/es/toast/style";

export default {
  data() {
    return {
      recordOn:false,
      showText:"",
      recognition:null,
      endFlg:false,
    };
  },
  components: {
    Header
  },
  mounted() {
    // this.initSocket();
  },
  beforeUnmount() {
    if(this.recognition){
      this.recognition.stop();
    }
  },
  methods: {
    onStart(){
      this.recordOn = true;
      this.endFlg = false;
      if(this.recognition){
        this.recognition.start()
      }else{
        var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        this.recognition = new SpeechRecognition();
        // 设置识别语言
        this.recognition.lang = 'ja-JP';
        // this.recognition.lang = 'zh-CN';
        // 设置连续识别
        this.recognition.continuous = true;
        // 返回临时结果
        this.recognition.interimResults = false;
        // 返回的可能匹配值的数量 默认值1
        this.recognition.maxAlternatives = 1;
        // 开始识别
        this.recognition.start();
        // 接收、处理结果
        this.recognition.onresult = (event) => {
          var last = event.results.length - 1;
          if ( event.results[last][0].transcript && event.results[last][0].transcript !="") {
            this.showText += "<br>"+event.results[last][0].transcript;
          }
        };
        this.recognition.onerror = (event)=>{
          console.log('エラー: ' + event.error);
        };
        this.recognition.onend = () => {
          if(!this.endFlg){
            this.recognition.start();
          }
        };
      }
    },
    onStop(){
      this.recordOn = false;
      this.endFlg = true;
      this.recognition.stop();
    },
    onClickLeft() {
      history.back();
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
    },
  },

  computed: {
  },
  watch: {},
};
</script>

<style scoped>
.btn-start{
  position: fixed;
  width: 100px;
  bottom: 95px;
  left:15%;
  padding: 10px;
  z-index: 1;
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
.btn-stop{
  position: fixed;
  width: 100px;
  bottom: 95px;
  right:15%;
  padding: 10px;
  z-index: 1;
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
.showTextClass{
  margin:10px;
  height: 60vh;
  overflow-y: scroll;
}
</style>
